import { Injectable } from "@angular/core";

@Injectable()
export class ProcessService {

	public id: any;
	public processId: any;

	public fichasCadastrais: any;

	public usuario: any = {};
	public historicoAtivo: any = {};
	public processo: any = {};

}


// WEBPACK FOOTER //
// ./src/services/process.service.ts